let init = function( publishPath = "" ) {

    /* Quantum Metrics Third Party */

    let insertScript = function( script ) {

        var newScript = document.createElement( 'script' );
        newScript.setAttribute( 'charset', 'UTF-8' );
        newScript.setAttribute( 'src', script );
        newScript.setAttribute( 'defer', '' );
        document.getElementsByTagName( 'head' ).item( 0 ).appendChild( newScript );

    };

    if ( publishPath === 'prod' || publishPath === 'beta' ) {

        insertScript( '//cdn.quantummetric.com/qscripts/quantum-homedepot.js' );

    } else {

        insertScript( '//cdn.quantummetric.com/qscripts/quantum-homedepot-test.js' );

    }

};

export {
    init
};